var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckboxRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkbox-red"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6667 0.5H1.33333C0.6 0.5 0 1.1 0 1.83333V11.1667C0 11.9 0.6 12.5 1.33333 12.5H10.6667C11.4 12.5 12 11.9 12 11.1667V1.83333C12 1.1 11.4 0.5 10.6667 0.5ZM5.14 9.36C4.88 9.62 4.46 9.62 4.2 9.36L1.80667 6.96667C1.54667 6.70667 1.54667 6.28667 1.80667 6.02667C2.06667 5.76667 2.48667 5.76667 2.74667 6.02667L4.66667 7.94667L9.25333 3.36C9.51333 3.1 9.93333 3.1 10.1933 3.36C10.4533 3.62 10.4533 4.04 10.1933 4.3L5.14 9.36Z",
    fill: "#E18F91"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxRed);
export default __webpack_public_path__ + "static/media/checkbox-red.a5d382389da618209347bf04f13bbc0f.svg";
export { ForwardRef as ReactComponent };